<script>
import {Link} from "@inertiajs/vue3";
import initSidebar from "@/externals/sidebarmenu";

export default {
	components: {
		Link
	},
	mounted() {
		this.$nextTick(() => {
			initSidebar();
		});
	}
}
</script>

<template>
	<aside class="left-sidebar">
		<div class="scroll-sidebar">
			<nav class="sidebar-nav">
				<ul id="sidebarnav">
					<li class="nav-small-cap pt-0">--- MENU</li>
					<li>
						<Link class="waves-effect waves-dark" :href="route('dashboard')" aria-expanded="false">
							<i class="bi bi-house"></i>
							<span class="hide-menu">Dashboard</span>
						</Link>
					</li>
					<li v-if="$page.props.auth.permissions.includes('manage users')">
						<Link class="waves-effect waves-dark" :href="route('users.index')" :class="{'active': $page.component.startsWith('users')}" aria-expanded="false">
							<i class="bi bi-people"></i>
							<span class="hide-menu">Gebruikers</span>
						</Link>
					</li>
					<li v-if="$page.props.auth.permissions.includes('manage customers')">
						<Link class="waves-effect waves-dark" :href="route('customers.index')" :class="{'active': $page.component.startsWith('customers') || $page.component.startsWith('customer_products')}" aria-expanded="false">
							<i class="bi bi-people"></i>
							<span class="hide-menu">Klanten</span>
						</Link>
					</li>
					<li v-if="$page.props.auth.permissions.includes('manage appointments')">
						<Link class="waves-effect waves-dark" :href="route('appointments.index')" aria-expanded="false">
							<i class="bi bi-calendar-week"></i>
							<span class="hide-menu">Agenda</span>
						</Link>
					</li>
					<li v-if="!$page.props.auth.permissions.includes('manage appointments') && $page.props.auth.permissions.includes('see owned appointments')">
						<Link class="waves-effect waves-dark" :href="route('appointments.employee', {user: $page.props.auth.user.id})" aria-expanded="false">
							<i class="bi bi-calendar-week"></i>
							<span class="hide-menu">Agenda</span>
						</Link>
					</li>
					<li v-if="$page.props.auth.permissions.includes('manage all cylinders') || $page.props.auth.permissions.includes('manage owned cylinders')">
						<Link class="waves-effect waves-dark" :href="route('cylinders.index')" aria-expanded="false">
							<i class="bi bi-database"></i>
							<span class="hide-menu">Cilinders</span>
						</Link>
					</li>
					<li v-if="$page.props.auth.permissions.includes('manage products') || $page.props.auth.permissions.includes('manage price_bundles')" :class="{'active': $page.component.startsWith('products') || $page.component.startsWith('maintenance_histories') || $page.component.startsWith('tester_types') || $page.component.startsWith('price_bundles')}">
						<a class="has-arrow waves-effect waves-dark" href="javascript:void(0)" aria-expanded="false">
							<i class="bi bi-boxes"></i>
							<span class="hide-menu">Producten</span>
						</a>

						<ul aria-expanded="false" class="collapse" :class="{'in': $page.component.startsWith('products') || $page.component.startsWith('maintenance_histories') || $page.component.startsWith('tester_types') || $page.component.startsWith('price_bundles') }">
							<li v-if="$page.props.auth.permissions.includes('manage products')">
								<Link :class="{'active': $page.component.startsWith('products') || $page.component.startsWith('maintenance_histories')}" :href="route('products.index')">Producten</Link>
							</li>
              <li v-if="$page.props.auth.permissions.includes('manage products')">
                <Link :class="{'active': $page.component.startsWith('parts')}" :href="route('parts.index')">Onderdelen</Link>
              </li>
							<li v-if="$page.props.auth.permissions.includes('manage products')">
								<Link :class="{'active': $page.component.startsWith('tester_types')}" :href="route('tester_types.index')">Meetmiddelen</Link>
							</li>
							<li v-if="$page.props.auth.permissions.includes('manage price_bundles')">
								<Link :class="{'active': $page.component.startsWith('price_bundles')}" :href="route('price_bundles.index')">Kortingsbundels</Link>
							</li>
						</ul>
					</li>
          <li v-if="$page.props.auth.permissions.includes('see knowledge_base')">
            <a class="has-arrow waves-effect waves-dark" href="javascript:void(0)" aria-expanded="false">
              <i class="bi bi-mortarboard-fill"></i>
              <span class="hide-menu">Kennisbank</span>
            </a>

            <ul aria-expanded="false" class="collapse" :class="{'in': $page.component.startsWith('messages')}">
              <li v-if="$page.props.auth.permissions.includes('manage knowledge_base')">
                <Link :href="route('knowledge_base.messages.index')" :class="{'active': ($page.component.startsWith('messages') && !$page.component.startsWith('messages/overview'))}" aria-expanded="false">
                  <i class="bi bi-chat-left-text-fill pe-2"></i>
                  Berichten
                </Link>
              </li>
              <li v-if="$page.props.auth.permissions.includes('manage knowledge_base')">
                <Link :href="route('knowledge_base.tags.index')" :class="{'active': $page.component.startsWith('tags')}" aria-expanded="false">
                  <i class="bi bi-tags-fill pe-2"></i>
                  Labels
                </Link>
              </li>
              <li v-if="$page.props.auth.permissions.includes('see knowledge_base')">
                <Link :href="route('knowledge_base.messages.overview')" :class="{'active': $page.component.startsWith('messages/overview')}" aria-expanded="false">
                  <i class="bi bi-wechat pe-2"></i>
                  Overzicht
                </Link>
              </li>
            </ul>
          </li>
				</ul>
			</nav>
		</div>
	</aside>
</template>